 export enum LinearNavigation {
    Prev,
    Next
}
